export const enum EventType {
  QueueStarted = 'QueueStarted',
  PausingQueue = 'PausingQueue',
  QueuePaused = 'QueuePaused',
  ActionErrored = 'ActionErrored',
  ActionAdded = 'ActionAdded',
  BeforeActionAdd = 'BeforeActionAdd',
  ResendingAction = 'ResendingAction',
}
